<div class="flex min-h-screen items-center justify-center">
  <div class="flex flex-row items-center justify-center space-x-2">
    <p class="text-3xl font-bold">Loading</p>
    <mat-spinner
      color="warn"
      class="spinner bg-transparent"
      [strokeWidth]="3"
      [diameter]="30"
    ></mat-spinner>
  </div>
</div>
